import { QueryClient } from '@tanstack/react-query';

// Single shared instance so non-React code (e.g. the app-level upload store) can
// invalidate caches after mutating server state, using the same client the
// QueryClientProvider serves to the component tree.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // 10 minutes (personal use, data doesn't change often)
      gcTime: 30 * 60 * 1000, // 30 minutes cache retention
      retry: 2,
      refetchOnWindowFocus: false, // Don't refetch on tab focus (personal use)
    },
  },
});
